import { render, staticRenderFns } from "./CategoryCreateModal.vue?vue&type=template&id=3b9df054&scoped=true"
import script from "./CategoryCreateModal.vue?vue&type=script&lang=js"
export * from "./CategoryCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryCreateModal.vue?vue&type=style&index=0&id=3b9df054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9df054",
  null
  
)

export default component.exports